export const FORM_REQUEST_MODE = {
  CREATE: 'create',
  TEMPLATE_CREATE: 'templateCreate',
  EDIT: 'edit',
  INTERNAL_READ_ONLY: 'internalReadOnly',
  PUBLIC_READ_ONLY: 'publicReadOnly'
};

const PUBLIC_DECISIONABLE_STATUSES = [10, 20];

export const getFormRequestModeConfig = ({ mode, dataForm }) => {
  const isPublicView = mode === FORM_REQUEST_MODE.PUBLIC_READ_ONLY;
  const isTemplateFlow = mode === FORM_REQUEST_MODE.TEMPLATE_CREATE;
  const isInternalView = mode === FORM_REQUEST_MODE.INTERNAL_READ_ONLY || mode === FORM_REQUEST_MODE.EDIT;
  let viewType = 'create';

  if (mode === FORM_REQUEST_MODE.EDIT) {
    viewType = 'edit';
  } else if (mode === FORM_REQUEST_MODE.INTERNAL_READ_ONLY || mode === FORM_REQUEST_MODE.PUBLIC_READ_ONLY) {
    viewType = 'readOnly';
  }

  return {
    viewType,
    isPublicView,
    isTemplateFlow,
    isStepperMode: isTemplateFlow || isPublicView || isInternalView,
    showReadOnlyBackButton: mode === FORM_REQUEST_MODE.INTERNAL_READ_ONLY,
    canShowPublicDecisionActions:
      isPublicView &&
      PUBLIC_DECISIONABLE_STATUSES.includes(dataForm?.status) &&
      dataForm?.scopeData?.accessScope !== 'interno'
  };
};
